export default {
  search: {
    title: 'Hvor vil du reise?',
    departureDate: 'Utreise',
    returnDate: 'Retur',
    continue: 'Fortsett',
  },
  travelPlanner: {
    search: {
      origin: 'Fra',
      destination: 'Til',
      switchDirection: 'Bytt retning',
    },
    passenger: {
      addPassenger: 'Legg til',
      removePassenger: 'Fjern',
      travelCard: {
        placeholder: 'Velg reisekort',
        addTravelCard: 'Legg til reisekort',
        reminder: 'Husk at du må vise gyldig periodebillett ved ombordstigning. ',
      },
    },
  },
  common: {
    actions: {
      clear: 'Tøm feltet',
      save: 'Lagre',
    },
    passenger: {
      title: 'Passasjerer',
      passengers: 'passasjerer',
    },
  },
  components: {
    button: {
      cancel: 'Avbryt',
    },
    dropdown: {
      select: 'Velg',
      noResults: 'Ingen resultater funnet',
    },
  },
  descriptions: {
    passengerNames: {
      ADT: 'Voksen',
      CHD: 'Barn 0 - 5 år',
      YOU: 'Barn 6 - 17 år',
      STU: 'Student',
      SEN: 'Honnør',
      COM: 'Ledsager',
      CON: 'Vernepliktig',
    },
  },
}
